// DARAT AI assistant: server does the LLM + catalog tool calls; we render text + product rows.
import { $, api, esc, store, t } from "./util";
import { resultRow, loadIndex, findItems } from "./search";

const KEY = "darat_chat";
let history = store(KEY) || [];

function bubble(role, html) {
	const log = $("[data-chat-log]");
	const d = document.createElement("div");
	d.className = `ds-msg ds-msg--${role}`;
	d.innerHTML = html;
	log.appendChild(d);
	log.scrollTop = log.scrollHeight;
	return d;
}

function productsHTML(list) {
	return list && list.length ? `<div class="ds-msg__cards">${list.slice(0, 5).map((i) => resultRow(i)).join("")}</div>` : "";
}

export function initChat() {
	const form = $("[data-chat-form]");
	if (!form) return;
	history.slice(-10).forEach((m) => bubble(m.role === "user" ? "me" : "bot", esc(m.text) + productsHTML(m.items)));
	form.addEventListener("submit", async (e) => {
		e.preventDefault();
		const input = form.q;
		const q = input.value.trim();
		if (!q) return;
		input.value = "";
		bubble("me", esc(q));
		const typing = bubble("bot ds-msg--typing", "<span></span><span></span><span></span>");
		let reply;
		try {
			if (!(window.darat_store || {}).ai) throw new Error("ai-off");
			reply = await api("darat.storefront.ai.chat", { message: q, history: history.slice(-8).map(({ role, text }) => ({ role, text })) }, "POST");
		} catch (err) {
			// graceful fallback: local catalog search
			try {
				await loadIndex();
				const items = findItems(q).slice(0, 5);
				reply = { text: items.length ? t("هذه أقرب القطع لطلبك:", "Here are the closest matches:") : t("لم أجد قطعة مطابقة تماماً. أرسل لنا موديل جهازك على واتساب ونساعدك.", "No direct match. Send us your laptop model on WhatsApp and we'll help."), items };
			} catch (e2) { reply = { text: t("تعذّر الاتصال، حاول مرة أخرى.", "Connection problem, please try again."), items: [] }; }
		}
		typing.remove();
		bubble("bot", esc(reply.text) + productsHTML(reply.items));
		history.push({ role: "user", text: q }, { role: "assistant", text: reply.text, items: (reply.items || []).slice(0, 5) });
		history = history.slice(-20);
		store(KEY, history);
	});
}
